import { Configuration, UserApi } from '@/infrastructure/api/client_typescript';

export class GuestService {
  private userApi: UserApi;

  constructor(apiBaseUrl: string) {
    const config = new Configuration({
      basePath: apiBaseUrl,
    });

    this.userApi = new UserApi(config);
  }

  async createGuestUser() {
    try {
      const response = await this.userApi.createGuestTokenPair();
      return response.data;
    } catch (error) {
      throw error;
    }
  }
}
